import root from 'window-or-global';
import {setAuthResponseEvent} from '../SocialUtils';
import {ChannelStatus, SocialPlatform} from '../../../shared/types';
import {OAuth} from '../../reducers/oauth.reducer';

const openAuthPopup = (link, widthPopup = 516, heightPopup = 700) => {
    const popupWidth = widthPopup; // > root.innerHeight * 0.9 ? root.innerHeight * 0.9 : widthPopup;
    const popupHeight = heightPopup;

    const popupTop = `top=${root.innerHeight / 2 - popupHeight / 2},`;
    const popupLeft = `left=${root.innerWidth / 2 - popupWidth / 2},`;

    return root.open(
        link,
        '_blank',
        `toolbar=no,scrollbars=yes,resizable=yes,menubar=no,location=no,${popupTop +
            popupLeft},width=${popupWidth},height=${popupHeight}`
    );
};

const impossibleCheck = () => {
    setAuthResponseEvent({
        channelStatus: ChannelStatus.ERROR,
        impossibleCheck: true,
        //@ts-ignore
        violations: ['epic.affiliate.social.channels.errors.somethingWrong.v2']
    });
    return null;
};

export const getAuthPopup = (oauth: OAuth) => {
    if (oauth && oauth.platform in SocialPlatform) {
        return openAuthPopup(oauth.redirectUrl);
    }
    return impossibleCheck();
};

export const dispatchAuthResponseEvent = detail => {
    try {
        if (root.opener) {
            root.opener.document.dispatchEvent(
                /*global CustomEvent*/
                new CustomEvent('setAuthResponse', {
                    bubbles: true,
                    detail
                })
            );
        } else {
            // remove first to ensure wipe out old value, remove last to ensure it is clean
            root.localStorage.removeItem(detail.platform);
            root.localStorage.setItem(detail.platform, JSON.stringify(detail));
            root.localStorage.removeItem(detail.platform);
        }
    } catch (err) {
        console.error('Failed to send events to parent');
    }
};
